var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-autocomplete", {
    attrs: {
      items: _vm.items,
      loading: _vm.listLoading,
      "search-input": _vm.search,
      value: _vm.value,
      "cache-items": "",
      label: "銘柄選択",
    },
    on: {
      "update:searchInput": function ($event) {
        _vm.search = $event
      },
      "update:search-input": function ($event) {
        _vm.search = $event
      },
      input: _vm.updateStockName,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }